import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import * as UsersActions from '../../redux/users/actions';
import Spinner from 'react-spinkit';
import Paper from '@material-ui/core/Paper';
import get from 'lodash/get';
import find from 'lodash/find';
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Button} from '@material-ui/core';

import ChipCategory from '../../components/ChipCategory';
import useStyles from './styles';
import ChipCategoryClosed from '../../components/ChipCategoryClosed';
import {fetchSkillsRequested} from '../../store/skills/actions';
import {editUserRequested, fetchUserRequested} from '../../store/users/actions';
import ChipCity from "../../components/ChipCity";
import {fetchCitiesRequested} from "../../store/cities/actions";

function UserEditPage() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const {id} = useParams();
    const {skills} = useSelector(state => state.skills);
    const cities = get(useSelector(state => state.cities), 'cities', []);
    const {user, isUserLoading} = useSelector(state => state.users);
    const [editingUser, setEditingUser] = useState(user);
    const [saveUser, setSaveUser] = useState(false);

    const [error, setError] = useState(false);

    useEffect(() => {
        setEditingUser(user);
    }, [user])

    useEffect(() => {
        dispatch(fetchSkillsRequested());
        dispatch(fetchCitiesRequested());
        dispatch(fetchUserRequested({id}))
    }, []);

    const countBySkillFromRecommendations = (skill, recommendations) => {
        const foundRecommendation = recommendations.find((eachRecommendation) => eachRecommendation.skill.id === skill.id);

        if (foundRecommendation !== undefined) {
            return foundRecommendation.count;
        } else {
            return 0;
        }
    };

    const handleAddSkill = (i) => {
        const values = map(i, (option) => (find(skills, {id: option})));
        const openSkills = uniq([...editingUser.skills, ...values]);
        setEditingUser({
            ...editingUser,
            skills: [...editingUser.skills, ...openSkills]
        });
    };

    const handleSave = (event) => {
        event.preventDefault();
        setError(null);
        dispatch(editUserRequested({editedUser: {...user, ...editingUser}}))
        setSaveUser(true);
    };

    const handleChange = (event) => {
        setEditingUser({
            ...editingUser,
            [event.target.name]: event.target.value
        });
    };

    if (saveUser) {
        history.goBack();
    }
    if (isUserLoading || error) {
        return (
            <div>
                <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
                <div className="overlay">
                </div>
            </div>
        );
    }
    if (!user) {
        return (<div className="alert alert-danger">
            <strong>Ошибка!</strong> пользователь не найден
        </div>);
    }

    return (
        <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSave}>
            <Paper className={classes.paper}>
                <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.display_name}
                            name="display_name"
                            type="text"
                            label="Имя и фамилия"
                        />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.phone_number}
                            name="phone_number"
                            type="text"
                            label="Телефон"
                        />
                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.instagram_account}
                            name="instagram_account"
                            type="text"
                            label="Instagram"
                        />
                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.vk_account}
                            name="vk_account"
                            type="text"
                            label="Vk"
                        /></Grid>
                    <Grid item xs={4} sm={4}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.facebook_account}
                            name="facebook_account"
                            type="text"
                            label="Facebook"
                        /></Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.description}
                            name="description"
                            type="text"
                            label="Описание"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            onChange={handleChange}
                            value={editingUser.internal_description}
                            multiline={true}
                            name="internal_description"
                            type="text"
                            label="Внутренний комментарий"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ChipCategory
                            setFieldValue={(i) => {
                                console.log('i', i);
                                const value = map(i, (option) => (find(skills, {id: option})));
                                handleChange({
                                    target: {
                                        name: 'skills',
                                        value
                                    }
                                });
                            }}
                            selectedIds={map(editingUser.skills, (eachSkill) => (eachSkill.id))}
                            collection={skills.map((eachSkill) => ({
                                id: eachSkill.id,
                                name: eachSkill.name,
                                count: countBySkillFromRecommendations(eachSkill, get(editingUser, 'recommendations', []))
                            }))}
                            fieldLabel='Открытые категории'
                            fieldName='skills'
                            fieldDell={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Paper style={{textAlign: 'left'}}>
                            <p>Не открытые категории</p>
                            <ChipCategoryClosed
                                setFieldValue={(i) => {
                                    handleAddSkill([i]);
                                }}
                                selectedIds={editingUser.recommendations
                                    .filter((eachRecommendation) =>
                                        editingUser.skills.find((eachEditingSkill) => eachRecommendation.skill.id === eachEditingSkill.id) === undefined
                                    )
                                    .map((eachSkill) => (eachSkill.skill.id))}
                                collection={skills.map((eachSkill) => ({
                                    id: eachSkill.id,
                                    name: eachSkill.name,
                                    count: countBySkillFromRecommendations(eachSkill, get(editingUser, 'recommendations', []))
                                }))}
                                fieldLabel='Не открытые категории'
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <ChipCity
                            setFieldValue={(i) => {
                                const value = map(i, (option) => (find(cities, {id: option})));
                                handleChange({
                                    target: {
                                        name: 'cities',
                                        value
                                    }
                                });
                            }}
                            selectedIds={map(editingUser.cities, (city) => (city.id))}
                            collection={cities}
                            fieldLabel='Города пользователя'
                            fieldName='cities'
                            fieldDell={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                        >
                            Сохранить
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
    );
}

export default UserEditPage;



// WEBPACK FOOTER //
// ./src/pages/UserEditPage/index.jsx